import React from 'react';
import Datepicker from 'react-datepicker';
import TimeSelect from '../SharedComponents/TimeSelect';

const DateTimeSelect = props => {
    const { matchDateMoment, matchTime, onDateChange, onTimeChange, maxDate, minDate } = props;
    return (
        <div className="row">
            <div className="col-7 pr4">
                <div className="input-wrapper">
                    <Datepicker
                        className="form-control"
                        selected={matchDateMoment}
                        onChange={onDateChange}
                        minDate={minDate}
                        maxDate={maxDate}
                    />
                </div>
            </div>
            <div className="col-5 pl0">
                <div className="input-wrapper">
                    <TimeSelect time={matchTime} onChange={onTimeChange} timeOptional={true} />
                </div>
            </div>
        </div>
    );
};

export default DateTimeSelect;
